import { Controller, useFormContext } from 'react-hook-form';
import { Grid, Typography, Card, CardContent, Checkbox, FormControlLabel } from '@mui/material';

// interface Checkboxes {
//   information?: boolean;
//   smsFraudulent?: boolean;
//   smsAllTransactions?: boolean;
//   termsAndConditions: boolean;
// }

export const StepDataProtection = () => {
  const { control } = useFormContext();

  return (
    <Grid container>
      <Grid item xs={12}>
        <Card>
          <CardContent>
            <Typography paragraph={true}>
              In relation to the Data Protection Act (Chapter 440 of the Laws of Malta), Insignia Cards Limited will process the data provided in this
              Application Form and any other data which you subsequently give to us in any manner, for the following purposes:
            </Typography>
            <Typography>- To provide, develop or improve our products and services, or otherwise for legitimate business reasons;</Typography>
            <Typography>- For internal assessment and analysis (including credit and/or behaviour scoring, market and product analysis);</Typography>
            <Typography>
              - If we are under a duty to disclose or share your data in order to comply with any legal or regulatory obligation; or to protect our
              rights, property, or safety of our employees, customers, or others.
            </Typography>
            <Typography paragraph={true}>
              <span style={{ visibility: 'hidden' }}>-</span> This includes exchanging information with other companies and organisations for the
              purposes of fraud protection and credit risk reduction.
            </Typography>
            <Typography paragraph={true}>
              Please note that your personal data may, for the above purposes, also be disclosed to or shared with our employees (present or future),
              other entities in the Insignia family of companies, associates, agents and other third parties entrusted with providing Insignia Cards
              Limited or the customer with services related to the card. Whilst Insignia Cards Limited may periodically request that you re-confirm
              the above data, you should inform us immediately if any such data has changed. You have the right to ask us to inform you about the
              personal data we hold about you, and to request the correction of that data where necessary. From time-to-time, we would like to inform
              you (by post, telephone, fax, e-mail or other electronic means) about our future products and services.
            </Typography>
            {/* TODO: marketing in supplementary form
              <FormControlLabel
              style={{ marginLeft: '0' }}
              control={
                <Checkbox
                  checked={applicationData?.marketing}
                  color="primary"
                  value={applicationData?.marketing}
                  onChange={(e) => {
                    onChangeAdjustment(e, 'marketing');
                  }}
                />
              }
              label="If you do not want to receive such information, please tick this box."
              labelPlacement="start"
            /> */}
            <Typography paragraph={true}>
              Insignia Cards Limited respects your privacy, and will not share your personal data with third parties for marketing purposes.
            </Typography>
            {/* <FormGroup row>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={applicationData?.fraudSMS}
                    color="primary"
                    value={applicationData?.fraudSMS}
                    onChange={(e) => {
                      onChangeAdjustment(e, 'fraudSMS');
                    }}
                  />
                }
                label="By default we will send you SMS notifications about potential fraudulent transactions. If you would not like to receive
                fraudulent SMS alerts please tick here."
              />
              <FormControlLabel
                control={
                  <Checkbox
                    checked={applicationData?.allTransactionsSMS}
                    color="primary"
                    value={applicationData?.allTransactionsSMS}
                    onChange={(e) => {
                      onChangeAdjustment(e, 'allTransactionsSMS');
                    }}
                  />
                }
                label="If you would like to receive SMS notifications for all card transactions please tick here."
              />
            </FormGroup> */}
            <FormControlLabel
              label='I confirm that I have read and accept the Terms and Conditions and Privacy Notice of each Insignia Cards Limited and
              Insignia Lifestyle Boutique Limited. *'
              control={
                <Controller
                  name='acceptedTC'
                  control={control}
                  render={({ field }) => <Checkbox {...field} color='primary' checked={field.value} />}
                />
              }
            />
            <Grid item xs={12} style={{ marginTop: '1rem' }}>
              <Typography variant='body1'>** Definition of ‘Politically Exposed Persons’</Typography>
              <Typography variant='body1'>
                Politically exposed persons are individuals who have been entrusted with prominent public functions whose position in public life may
                make them vulnerable to corruption. The definition extends to immediate family members and persons known to be close associates.
              </Typography>
              <Typography variant='body1'>(a) the term ‘prominent public functions’ shall include the following:</Typography>
              <Typography variant='body1'>
                (i) Heads of State, Heads of Government, Ministers and Deputy and Assistant Ministers and Parliamentary Secretaries;
              </Typography>
              <Typography variant='body1'>(ii) Members of Parliament;</Typography>
              <Typography variant='body1'>
                (iii) members of the Courts or of other high-level judicial bodies whose decisions are not subject to further appeal, except in
                exceptional circumstances;
              </Typography>
              <Typography variant='body1'>(iv) members of courts of auditors, Audit Committees or of the boards of central banks;</Typography>
              <Typography variant='body1'>(v) ambassadors, charges d’affaires and other high-ranking officers in the armed forces;</Typography>
              <Typography variant='body1'>
                (vi) members of the administrative, management or boards of State-owned corporations, and where applicable, for the purposes of
                subparagraphs (i) to (v), shall include positions held at the Community or international level but shall exclude middle ranking or
                more junior official positions.
              </Typography>
              <Typography variant='body1'>(b) the term ‘immediate family members’ shall include the following:</Typography>
              <Typography variant='body1'>(i) the spouse, or any partner recognised by national law as equivalent to the spouse;</Typography>
              <Typography variant='body1'>(ii) the children and their spouses or partners; and</Typography>
              <Typography variant='body1'>(iii) the parents.</Typography>
              <Typography variant='body1'>(c) the term ‘persons known to be close associates’ shall include the following:</Typography>
              <Typography variant='body1'>
                (i) a natural person known to have joint beneficial ownership of a body corporate or any other form of legal arrangement, or any other
                close business relations with that politically exposed person;
              </Typography>
              <Typography variant='body1'>
                (ii) a natural person who has sole beneficial ownership of a body corporate or any other form of legal arrangement that is known to
                have been established for the benefit of that politically exposed person.
              </Typography>
            </Grid>
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};
